<div class="app-price-unit-wrapper" [ngClass]="customClass">
  <!-- Header Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
  ></app-label>

  <!-- Input Container -->
  <div
    class="app-price-unit-container"
    [ngClass]="[
      'app-price-unit-container--' + (size || 'md'),
      isFocused ? 'app-price-unit-container--focused' : '',
      hasError ? 'app-price-unit-container--error' : '',
      disabled ? 'app-price-unit-container--disabled' : '',
      containerClass
    ]"
  >
    <!-- Price Text Input -->
    <input
      type="text"
      class="app-price-unit__input"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [readonly]="readonly"
      (input)="onInput($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
    />

    <!-- Vertical Divider -->
    <div class="app-price-unit__divider"></div>

    <!-- Unit Dropdown Trigger Button -->
    <div class="app-price-unit__pill-wrap">
      <button
        type="button"
        class="app-price-unit__pill"
        [ngClass]="{ 'app-price-unit__pill--open': isUnitDropdownOpen }"
        [disabled]="disabled"
        (click)="toggleUnitDropdown($event)"
      >
        <span class="app-price-unit__pill-label">{{ selectedUnitLabel }}</span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="app-price-unit__pill-icon"
          [ngClass]="{ 'app-price-unit__pill-icon--open': isUnitDropdownOpen }"
        >
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </button>

      <!-- Unit Popover Dropdown -->
      <div
        *ngIf="isUnitDropdownOpen"
        class="app-price-unit__dropdown"
        (click)="$event.stopPropagation()"
      >
        <!-- Search Box -->
        <div *ngIf="searchable" class="app-price-unit__search-box">
          <div class="app-price-unit__search-wrap">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="#9AA9BE" class="app-price-unit__search-icon">
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
              />
            </svg>
            <input
              type="text"
              class="app-price-unit__search-input"
              [placeholder]="searchPlaceholder"
              [value]="unitSearchTerm"
              (input)="onUnitSearchInput($event)"
              (click)="$event.stopPropagation()"
              autofocus
            />
          </div>
        </div>

        <!-- Options List -->
        <div class="app-price-unit__options-list">
          <div
            *ngFor="let opt of filteredUnitOptions"
            class="app-price-unit__option"
            [ngClass]="{
              'app-price-unit__option--selected': (unitValue !== null && unitValue !== undefined && unitValue !== '') && (opt.value === unitValue || String(opt.value) === String(unitValue)),
              'app-price-unit__option--disabled': opt.disabled
            }"
            (click)="selectUnit(opt, $event)"
          >
            <span class="app-price-unit__option-label">{{ opt.label }}</span>
            <svg
              *ngIf="(unitValue !== null && unitValue !== undefined && unitValue !== '') && (opt.value === unitValue || String(opt.value) === String(unitValue))"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0386FF"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>

          <div *ngIf="filteredUnitOptions.length === 0" class="app-price-unit__no-options">
            No units found
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-price-unit__error">
    {{ errorMsg }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-price-unit__helper">
    {{ helperText }}
  </div>
</div>
